import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './constants'

/* global contextPath */

const Trans = {
  get defaultLanguage () {
    return DEFAULT_LANGUAGE
  },
  get supportedLanguages () {
    return SUPPORTED_LANGUAGES
  },
  getCurrentLanguage (i18n) {
    return i18n.locale
  },
  loadAndSetLanguageFile (lang, i18n, after) {
    if (lang == null || lang === i18n.locale) return

    console.debug(`Loading language translations [language=${lang}]`)

    lang = lang.replace('_', '-')

    $.getJSON(contextPath + '/translation/json?lang=' + lang, function (data) {
      i18n.setLocaleMessage(lang, data)
      i18n.locale = lang
      after && after()
    })
  }
}

export { Trans }
